import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import Util from '@/util'
import PricingApi from '@/api/pricing'
import {
  CANCEL_SUBSCRIPTION_EVENT,
  CANCEL_SUBSCRIPTION_STEPS,
} from '@/constant/cancelSubscription'

export default {
  data() {
    return {
      isGetOfferProcessing: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    async getOffer() {
      this.isGetOfferProcessing = true

      try {
        const res = await PricingApi.extendSubscription()
        const newSubscriptionEndDate = res && res.body && res.body.endDate
        this.$emit('updatePropData', {
          newSubscriptionEndDate,
        })
        this.$emit(CANCEL_SUBSCRIPTION_EVENT, CANCEL_SUBSCRIPTION_STEPS.GET_OFFER)
      } catch (error) {
        Sentry.captureException(error)
        Util.showToastError(this.$i18nPresenter.t(
          'Something went wrong, please check your connection or contact us for support',
        ))
      } finally {
        this.isGetOfferProcessing = false
      }
    },
  },
}
